import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { IntegrationTypeIcon } from '../../music24/components/IntegrationTypeIcon/IntegrationTypeIcon';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Four marks fit the column; the rest are counted. */
const MAX_VISIBLE_MARKS = 4;

interface CatalogServiceMarksProps {
  serviceLinks: Record<string, string> | null;
}

/** Where the release can already be heard, from the snapshot taken at claim. */
const CatalogServiceMarksComponent: React.FC<CatalogServiceMarksProps> = ({ serviceLinks }) => {
  const intl = useIntl();
  const integrationTypes = useMemo(() => Object.keys(serviceLinks ?? {}), [serviceLinks]);

  if (integrationTypes.length === 0) {
    return (
      <span className={styles.mutedCell}>
        {intl.formatMessage({ id: 'app.sml.catalog.services.none', defaultMessage: 'none yet' })}
      </span>
    );
  }

  const visible = integrationTypes.slice(0, MAX_VISIBLE_MARKS);
  const hidden = integrationTypes.length - visible.length;

  return (
    <span className={styles.marks}>
      {visible.map((integrationType) => (
        <IntegrationTypeIcon key={integrationType} integrationType={integrationType} size={17} />
      ))}
      {hidden > 0 && (
        <span className={styles.marksMore}>
          {intl.formatMessage({ id: 'app.sml.catalog.services.more', defaultMessage: '+{count}' }, { count: hidden })}
        </span>
      )}
    </span>
  );
};

export const CatalogServiceMarks = TypedMemo(CatalogServiceMarksComponent);
